"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LarixMarkets = void 0;
const models_1 = require("../models");
const bn_js_1 = __importDefault(require("bn.js"));
const models_2 = require("../models");
const models_3 = require("../models");
const models_4 = require("../models");
const utils_1 = require("../utils");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const models_5 = require("../models");
const models_6 = require("../models");
const constant_1 = require("../constant");
const utils_2 = require("../utils");
const production_1 = require("../config/production");
const type_1 = require("../type");
class LarixMarkets {
    constructor(connection, marketsConfig = production_1.MARKETS) {
        this.markets = [];
        this.allId = [];
        this.connection = connection;
        this.marketConfigs = marketsConfig;
        this.marketConfigs.forEach(marketConfig => {
            var _a;
            marketConfig.reserves.forEach(reserve => {
                this.allId.push(reserve.reserveId);
                this.allId.push(reserve.larixOraclePriceId);
            });
            (_a = marketConfig.lpReserves) === null || _a === void 0 ? void 0 : _a.forEach(lpReserve => {
                this.allId.push(lpReserve.reserveId);
                this.allId.push(lpReserve.ammID);
                this.allId.push(lpReserve.lpMint);
                this.allId.push(lpReserve.coinMintPrice);
                this.allId.push(lpReserve.pcMintPrice);
                this.allId.push(lpReserve.ammOpenOrders);
                this.allId.push(lpReserve.ammCoinMintSupply);
                this.allId.push(lpReserve.ammPcMintSupply);
                this.allId.push(lpReserve.farmPoolID);
                this.allId.push(lpReserve.farmPoolLpSupply);
            });
        });
    }
    loadReservesAndRewardApy() {
        return __awaiter(this, void 0, void 0, function* () {
            this.priceInfoMap = undefined;
            const response = yield Promise.all([
                this.getSlot(),
                this.getAllAccountsInfo(),
                (0, utils_2.getRaydiumPools)(),
                (0, utils_2.getLarixPrice)(),
                (0, utils_2.getMndePrice)(),
            ]);
            const currentSlot = new bn_js_1.default(response[0]);
            const allAccountInfo = response[1];
            const raydiumPairs = response[2];
            const larixPrice = response[3];
            const mndePrice = response[4];
            this.parserReserve(currentSlot, allAccountInfo);
            const priceInfo = new Map();
            priceInfo.set("MNDE", { price: mndePrice, decimals: 9 });
            priceInfo.set("LARIX", { price: larixPrice, decimals: 6 });
            this.calcRewardApy(raydiumPairs, priceInfo);
        });
    }
    loadReserves() {
        return __awaiter(this, void 0, void 0, function* () {
            this.priceInfoMap = undefined;
            const res = yield Promise.all([
                this.getSlot(),
                this.getAllAccountsInfo()
            ]);
            const currentSlot = new bn_js_1.default(res[0]);
            const allAccountInfo = res[1];
            this.parserReserve(currentSlot, allAccountInfo);
        });
    }
    loadRewardApy() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield Promise.all([
                (0, utils_2.getRaydiumPools)(),
                (0, utils_2.getLarixPrice)(),
                (0, utils_2.getMndePrice)(),
            ]);
            const raydiumPairs = response[0];
            const larixPrice = response[1];
            const mndePrice = response[2];
            const priceInfo = new Map();
            priceInfo.set("MNDE", { price: mndePrice, decimals: 9 });
            priceInfo.set("LARIX", { price: larixPrice, decimals: 6 });
            this.calcRewardApy(raydiumPairs, priceInfo);
        });
    }
    calcRewardApy(raydiumPairs, priceInfo) {
        const larixPriceInfo = this.getPriceInfo(priceInfo, "LARIX");
        this.markets.forEach(marketData => {
            marketData.reserves.forEach(reserve => {
                if (reserve.state.info.isLP) {
                    this.calcReserveRewardApy(reserve, larixPriceInfo.price);
                    const lpInfo = reserve.state.info.lpInfo;
                    // @ts-ignore
                    const rewardAPriceInfo = this.getPriceInfo(priceInfo, lpInfo.rewardASymbol);
                    // @ts-ignore
                    const rewardBPriceInfo = this.getPriceInfo(priceInfo, lpInfo.rewardBSymbol);
                    this.calcPoolFeeApy(lpInfo, raydiumPairs);
                    this.calcLpApyDetails(lpInfo, reserve.liquidityPrice, rewardAPriceInfo, rewardBPriceInfo);
                }
                else {
                    this.calcReserveRewardApy(reserve, larixPriceInfo.price);
                }
            });
        });
    }
    parserReserve(currentSlot, accounts) {
        var _a;
        let index = 0;
        this.markets = [];
        for (const marketConfig of this.marketConfigs) {
            const marketData = {
                config: marketConfig,
                reserves: [],
                reservesMap: new Map(),
                reserveStates: []
            };
            marketConfig.reserves.forEach(reserveConfig => {
                const reserveState = (0, models_1.ReserveParser)(reserveConfig.reserveId, accounts[index++]);
                const marketPrice = (0, models_2.PriceParser)(reserveConfig.larixOraclePriceId, accounts[index++]);
                reserveState.info.liquidity.marketPrice = marketPrice.info.price.mul(new bn_js_1.default(10)
                    .pow(new bn_js_1.default(18 - marketPrice.info.expo)));
                const reserve = this.afterLoad(currentSlot, reserveState, reserveConfig);
                reserve.market = marketData;
                marketData.reserveStates.push(reserveState);
                marketData.reservesMap.set(reserveConfig.reserveId.toString(), reserve);
                marketData.reserves.push(reserve);
            });
            (_a = marketConfig.lpReserves) === null || _a === void 0 ? void 0 : _a.forEach(lpConfig => {
                const reserveState = (0, models_1.ReserveParser)(lpConfig.reserveId, accounts[index++]);
                const amm = (0, models_3.AmmParser)(lpConfig.ammID, accounts[index++]);
                const lpMint = (0, models_5.MintParser)(lpConfig.lpMint, accounts[index++]);
                const coinMintPrice = (0, models_2.PriceParser)(lpConfig.coinMintPrice, accounts[index++]);
                const pcMintPrice = (0, models_2.PriceParser)(lpConfig.pcMintPrice, accounts[index++]);
                const ammOpenOrders = (0, models_4.AmmOpenOrdersLayoutParser)(lpConfig.ammOpenOrders, accounts[index++]);
                const ammCoinMint = (0, models_1.TokenAccountParser)(lpConfig.ammCoinMintSupply, accounts[index++]);
                const ammPcMint = (0, models_1.TokenAccountParser)(lpConfig.ammPcMintSupply, accounts[index++]);
                const poolInfo = (0, models_6.FarmPoolParser)(lpConfig.farmPoolID, accounts[index++]);
                const farmPoolLpToken = (0, models_1.TokenAccountParser)(lpConfig.farmPoolLpSupply, accounts[index++]);
                reserveState.info.lpInfo = this.getLpInfo(lpConfig, poolInfo, lpMint, farmPoolLpToken);
                const lpPrice = this.getLpPrice(amm, ammOpenOrders, ammCoinMint, ammPcMint, coinMintPrice, pcMintPrice, lpMint);
                reserveState.info.liquidity.marketPrice = (0, utils_1.eX)(lpPrice, 18);
                const reserve = this.afterLoad(currentSlot, reserveState, lpConfig);
                reserve.market = marketData;
                marketData.reserveStates.push(reserveState);
                marketData.reservesMap.set(lpConfig.reserveId.toString(), reserve);
                marketData.reserves.push(reserve);
            });
            this.markets.push(marketData);
        }
    }
    afterLoad(currentSlot, reserveState, reserveConfig) {
        const reserve = {};
        reserve.reserveConfig = reserveConfig;
        reserve.state = reserveState;
        this.formatReserveBeforeRefresh(reserve);
        this.refreshReserve(currentSlot, reserve);
        this.formatReserveAfterRefresh(reserve);
        this.calcApy(reserve);
        return reserve;
    }
    formatReserveBeforeRefresh(reserve) {
        const info = reserve.state.info;
        reserve.collateralFactor = new bignumber_js_1.default(info.config.loanToValueRatio.toString()).div(100);
        reserve.liquidationThreshold = info.config.liquidationThreshold / 100;
        reserve.miningSpeed = (0, utils_1.eX)(info.bonus.totalMiningSpeed.toString(), -6);
        reserve.dailyMining = reserve.miningSpeed.times(constant_1.REAL_SLOTS_PER_DAY);
        reserve.supplyMiningRate = new bignumber_js_1.default(info.bonus.kinkUtilRate.toNumber()).div(100);
        reserve.borrowMiningRate = reserve.state.info.isLP ? new bignumber_js_1.default(0) : new bignumber_js_1.default(1).minus(reserve.supplyMiningRate);
        reserve.depositLimit = (0, utils_1.eX)(info.depositLimit.toString(), -info.liquidity.mintDecimals);
        reserve.totalCollateralTokenSupply = (0, utils_1.eX)(info.collateral.mintTotalSupply.toString(), -1 * Number(info.liquidity.mintDecimals));
        reserve.borrowInterestFee = (0, utils_1.eX)(info.config.fees.borrowInterestFeeWad.toString(), -18);
        reserve.liquidityPrice = (0, utils_1.eX)(info.liquidity.marketPrice.toString() || "0", -18);
        const totalAvailable = new bignumber_js_1.default(info.liquidity.availableAmount.toString()).minus((0, utils_1.eX)(info.liquidity.ownerUnclaimed.toString(), -18)).toString();
        reserve.totalAvailableAmount = totalAvailable.startsWith("-") ? constant_1.BIG_NUMBER_ZERO : (0, utils_1.eX)(totalAvailable, -info.liquidity.mintDecimals);
        reserve.totalAvailableValue = reserve.totalAvailableAmount.times(reserve.liquidityPrice);
        reserve.utilizationRate = this.getUtilizationRate(info);
    }
    refreshReserve(currentSlot, reserve) {
        this.accrueInterest(currentSlot, reserve);
        this.refreshRewardIndex(currentSlot, reserve);
    }
    accrueInterest(currentSlot, reserve) {
        const currentBorrowRate = this.getCurrentBorrowRate(reserve.state.info, reserve.utilizationRate);
        const slotInterestRate = currentBorrowRate.div(constant_1.SLOTS_PER_YEAR);
        const slotDiff = currentSlot.sub(reserve.state.info.lastUpdate.slot);
        const compoundedInterestRate = new bignumber_js_1.default(slotInterestRate.plus(1).pow(slotDiff.toNumber()));
        const info = reserve.state.info;
        info.liquidity.cumulativeBorrowRateWads =
            new bn_js_1.default(new bignumber_js_1.default(info.liquidity.cumulativeBorrowRateWads.toString())
                .times(compoundedInterestRate).toFixed(0));
        const newUnclaimed = new bn_js_1.default(new bignumber_js_1.default(info.liquidity.borrowedAmountWads.toString())
            .times(compoundedInterestRate.minus(1))
            .times(new bignumber_js_1.default(info.config.fees.borrowInterestFeeWad.toString()).
            div(constant_1.BIG_NUMBER_WAD))
            .toFixed(0));
        info.liquidity.ownerUnclaimed = info.liquidity.ownerUnclaimed.add(newUnclaimed);
        info.liquidity.borrowedAmountWads =
            new bn_js_1.default(new bignumber_js_1.default(info.liquidity.borrowedAmountWads.toString())
                .times(compoundedInterestRate).toFixed(0));
    }
    refreshRewardIndex(currentSlot, reserve) {
        const info = reserve.state.info;
        const slotDiff = currentSlot.sub(info.lastUpdate.slot);
        const slotDiffTotalMining = new bignumber_js_1.default(info.bonus.totalMiningSpeed.toString()).times(new bignumber_js_1.default(slotDiff.toString()));
        if (!reserve.supplyMiningRate.eq(0)) {
            if (info.collateral.mintTotalSupply.cmp(constant_1.ZERO) !== 0) {
                const plus = slotDiffTotalMining.times(reserve.supplyMiningRate).div(new bignumber_js_1.default(info.collateral.mintTotalSupply.toString())).times(constant_1.BIG_NUMBER_WAD);
                const newIndex = new bignumber_js_1.default(info.bonus.lTokenMiningIndex.toString()).plus(plus).toString();
                info.bonus.lTokenMiningIndex = new bn_js_1.default(newIndex.split(".")[0]);
            }
        }
        if (!reserve.borrowMiningRate.eq(0)) {
            if (info.liquidity.borrowedAmountWads.cmp(constant_1.ZERO) !== 0) {
                const newIndex = new bignumber_js_1.default(info.bonus.borrowMiningIndex.toString()).plus(slotDiffTotalMining.times(reserve.borrowMiningRate).div(new bignumber_js_1.default(info.liquidity.borrowedAmountWads.toString()).div(constant_1.BIG_NUMBER_WAD).div((0, utils_1.eX)(info.liquidity.cumulativeBorrowRateWads.toString(), -18))).times(constant_1.BIG_NUMBER_WAD));
                info.bonus.borrowMiningIndex = new bn_js_1.default(newIndex.toFixed(0));
            }
        }
    }
    formatReserveAfterRefresh(reserve) {
        const info = reserve.state.info;
        reserve.cumulativeBorrowRate = (0, utils_1.eX)(info.liquidity.cumulativeBorrowRateWads.toString(), -18);
        reserve.totalBorrowedAmount = (0, utils_1.eX)(info.liquidity.borrowedAmountWads.toString(), -18 - info.liquidity.mintDecimals);
        reserve.totalBorrowedValue = reserve.totalBorrowedAmount.times(reserve.liquidityPrice);
        reserve.totalDepositAmount = (0, utils_1.eX)(info.liquidity.availableAmount.toString(), -info.liquidity.mintDecimals)
            .plus(reserve.totalBorrowedAmount)
            .minus((0, utils_1.eX)(info.liquidity.ownerUnclaimed.toString(), -18 - info.liquidity.mintDecimals));
        reserve.totalDepositValue = reserve.totalDepositAmount.times(reserve.liquidityPrice);
        if (reserve.totalCollateralTokenSupply.isZero() || reserve.totalDepositAmount.isZero()) {
            reserve.exchangeRate = constant_1.BIG_NUMBER_ONE;
        }
        else {
            reserve.exchangeRate = reserve.totalCollateralTokenSupply.div(reserve.totalDepositAmount);
        }
        // set utilizationRate again
        reserve.utilizationRate = this.getUtilizationRate(reserve.state.info);
    }
    calcApy(reserve) {
        const currentBorrowRate = this.getCurrentBorrowRate(reserve.state.info, reserve.utilizationRate);
        const slotInterestRate = currentBorrowRate.div(constant_1.SLOTS_PER_YEAR);
        reserve.borrowApy = new bignumber_js_1.default(Math.pow(slotInterestRate.plus(1).toNumber(), constant_1.REAL_SLOTS_PER_YEAR)).minus(1);
        reserve.supplyApy = reserve.borrowApy.times(0.8).times(reserve.utilizationRate);
    }
    getCurrentBorrowRate(reserve, utilizationRate) {
        const optimalUtilizationRate = new bignumber_js_1.default(reserve.config.optimalUtilizationRate).div(100);
        const lowUtilization = utilizationRate.lt(optimalUtilizationRate);
        if (lowUtilization || optimalUtilizationRate.eq(1)) {
            const normalizedRate = utilizationRate.div(optimalUtilizationRate);
            const minRate = new bignumber_js_1.default(reserve.config.minBorrowRate).div(100);
            const rateRange = new bignumber_js_1.default(reserve.config.optimalBorrowRate - reserve.config.minBorrowRate).div(100);
            return normalizedRate.times(rateRange).plus(minRate);
        }
        else {
            const normalizedRate = utilizationRate.minus(optimalUtilizationRate).div(new bignumber_js_1.default(1).minus(optimalUtilizationRate));
            const minRate = reserve.config.optimalBorrowRate / 100;
            const rateRange = new bignumber_js_1.default(reserve.config.maxBorrowRate - reserve.config.optimalBorrowRate).div(100);
            return normalizedRate.times(rateRange).plus(minRate);
        }
    }
    getUtilizationRate(reserve) {
        const borrowedAmount = new bignumber_js_1.default(reserve.liquidity.borrowedAmountWads.toString())
            .div(constant_1.BIG_NUMBER_WAD);
        const totalSupply = new bignumber_js_1.default(reserve.liquidity.availableAmount.toString()).plus(borrowedAmount).minus((0, utils_1.eX)(reserve.liquidity.ownerUnclaimed.toString(), -18));
        if (totalSupply.eq(0)) {
            return constant_1.BIG_NUMBER_ZERO;
        }
        if (reserve.liquidity.borrowedAmountWads.lt(constant_1.WAD)) {
            return constant_1.BIG_NUMBER_ZERO;
        }
        if (borrowedAmount.gt(totalSupply)) {
            return constant_1.BIG_NUMBER_ONE;
        }
        else {
            return borrowedAmount.div(totalSupply);
        }
    }
    calcReserveRewardApy(reserve, larixPrice) {
        if (larixPrice.eq(0)) {
            reserve.supplyRewardApy = 0;
            reserve.borrowRewardApy = 0;
        }
        else {
            reserve.supplyRewardApy =
                reserve.supplyMiningRate
                    .times(reserve.miningSpeed).times(constant_1.REAL_SLOTS_PER_DAY).times(365)
                    .times(larixPrice)
                    .div(reserve.totalDepositValue.isZero() ? 1 : reserve.totalDepositValue)
                    .times(reserve.reserveConfig.name === 'main' ? 10 : 1);
            reserve.borrowRewardApy =
                reserve.borrowMiningRate
                    .times(reserve.miningSpeed).times(constant_1.REAL_SLOTS_PER_DAY).times(365)
                    .times(larixPrice)
                    .div(reserve.totalBorrowedValue.isZero() ? 1 : reserve.totalBorrowedValue)
                    .times(reserve.reserveConfig.name === 'main' ? 10 : 1);
        }
    }
    calcPoolFeeApy(lpInfo, raydiumPairs) {
        var _a;
        const res = (_a = raydiumPairs.find((item) => item.amm_id === lpInfo.amm_id.toString())) === null || _a === void 0 ? void 0 : _a.apy;
        lpInfo.lpFeesApr = res;
    }
    calcLpApyDetails(lpInfo, lpPrice, rewardAPriceInfo, rewardBPriceInfo) {
        const tvl = lpInfo.farmPoolLpSupply.times(lpPrice);
        const rewardAOneYear = (0, utils_1.eX)(lpInfo.perBlock.times(rewardAPriceInfo.price).times(2 * 60 * 60 * 24 * 365).toString(), -rewardAPriceInfo.decimals);
        const rewardBOneYear = (0, utils_1.eX)(lpInfo.perBlockB.times(rewardBPriceInfo.price).times(2 * 60 * 60 * 24 * 365).toString(), -rewardBPriceInfo.decimals);
        const aprA = rewardAOneYear.div(tvl.isEqualTo(0) ? 1 : tvl).times(100);
        const aprB = rewardBOneYear.div(tvl.isEqualTo(0) ? 1 : tvl).times(100);
        const apyA = Math.pow((1 + Number(aprA.toFixed(4)) / 365 / 100), 365) - 1;
        const apyB = Math.pow((1 + Number(aprB.toFixed(4)) / 365 / 100), 365) - 1;
        const totalApr = aprA.plus(aprB);
        const totalApy = apyA + apyB;
        lpInfo.lpApr = new bignumber_js_1.default(totalApy);
        lpInfo.lpRewardApyA = new bignumber_js_1.default(apyA);
        lpInfo.lpRewardApyB = new bignumber_js_1.default(apyB);
    }
    getSlot() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.connection.getSlot("processed");
        });
    }
    getAllAccountsInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.allId.length <= 100) {
                return yield this.connection.getMultipleAccountsInfo(this.allId);
            }
            else if (this.allId.length <= 200) {
                const multipleAccountsInfo = yield Promise.all([
                    this.connection.getMultipleAccountsInfo(this.allId.slice(0, 100)),
                    this.connection.getMultipleAccountsInfo(this.allId.slice(100, this.allId.length))
                ]);
                return multipleAccountsInfo[0].concat(multipleAccountsInfo[1]);
            }
            else if (this.allId.length <= 300) {
                const multipleAccountsInfo = yield Promise.all([
                    this.connection.getMultipleAccountsInfo(this.allId.slice(0, 100)),
                    this.connection.getMultipleAccountsInfo(this.allId.slice(100, 200)),
                    this.connection.getMultipleAccountsInfo(this.allId.slice(200, this.allId.length))
                ]);
                return multipleAccountsInfo[0].concat(multipleAccountsInfo[1]).concat(multipleAccountsInfo[2]);
            }
        });
    }
    getPriceInfo(otherPriceInfo, symbol) {
        var _a;
        if (symbol === undefined || symbol === "") {
            return type_1.DEFAULT_PRICE_INFO;
        }
        let priceInfo = otherPriceInfo.get(symbol);
        if (priceInfo == undefined) {
            if (this.priceInfoMap == undefined) {
                this.loadPriceInfo();
            }
            priceInfo = (_a = this.priceInfoMap) === null || _a === void 0 ? void 0 : _a.get(symbol);
        }
        if (priceInfo == undefined) {
            priceInfo = type_1.DEFAULT_PRICE_INFO;
        }
        return priceInfo;
    }
    loadPriceInfo() {
        this.priceInfoMap = new Map();
        this.markets.forEach(marketDta => {
            marketDta.reserves.forEach(reserve => {
                // @ts-ignore
                this.priceInfoMap.set(reserve.reserveConfig.name, {
                    price: reserve.liquidityPrice,
                    decimals: reserve.state.info.liquidity.mintDecimals
                });
            });
        });
    }
    getLpPrice(amm, ammOpenOrders, ammCoinMint, ammPcMint, coinMintPrice, pcMintPrice, lpMint) {
        const totalAmount = this.getLpTotalAmount(amm, ammOpenOrders, ammCoinMint, ammPcMint);
        const coinTotalAmount = totalAmount.coinTotalAmount;
        const pcTotalAmount = totalAmount.pcTotalAmount;
        const coinPrice = (0, utils_1.eX)(coinMintPrice.info.price.toString(), -coinMintPrice.info.expo);
        const pcPrice = (0, utils_1.eX)(pcMintPrice.info.price.toString(), -pcMintPrice.info.expo);
        const lpTotalSupplyAmount = (0, utils_1.eX)(lpMint.info.supply.toString(), -lpMint.info.decimals);
        const price = (2 * Math.sqrt(coinTotalAmount.times(coinPrice).toNumber()) * Math.sqrt(pcTotalAmount.times(pcPrice).toNumber())) / lpTotalSupplyAmount.toNumber();
        return price;
    }
    getLpInfo(lpConfig, poolInfo, lpMint, farmPoolLpToken) {
        const lpInfo = {};
        // @ts-ignore
        lpInfo.rewardASymbol = lpConfig.rewardA;
        // @ts-ignore
        lpInfo.rewardBSymbol = lpConfig.rewardB;
        if ([4, 5].includes(lpConfig.version)) {
            lpInfo.perBlock = new bignumber_js_1.default(poolInfo.info.perBlock);
            lpInfo.perBlockB = new bignumber_js_1.default(poolInfo.info.perBlockB);
        }
        else {
            lpInfo.perBlock = new bignumber_js_1.default(0);
            lpInfo.perBlockB = new bignumber_js_1.default(poolInfo.info.rewardPerBlock);
        }
        lpInfo.farmPoolLpSupply = (0, utils_1.eX)(farmPoolLpToken.info.amount.toString(), -lpMint.info.decimals);
        lpInfo.amm_id = lpConfig.ammID;
        return lpInfo;
    }
    getLpTotalAmount(amm, ammOpenOrders, ammCoinMint, ammPcMint) {
        const coinTotalAmount = (0, utils_1.eX)(ammCoinMint.info.amount.add(ammOpenOrders.info.baseTokenTotal).sub(amm.info.needTakePnlCoin).toString(), -amm.info.coinDecimals.toNumber());
        const pcTotalAmount = (0, utils_1.eX)(ammPcMint.info.amount.add(ammOpenOrders.info.quoteTokenTotal).sub(amm.info.needTakePnlPc).toString(), -amm.info.pcDecimals.toNumber());
        return {
            coinTotalAmount: coinTotalAmount,
            pcTotalAmount: pcTotalAmount,
        };
    }
}
exports.LarixMarkets = LarixMarkets;
